A skill or competency asserted by the candidate.
